import { Injectable } from '@angular/core';
import { environment } from '../../../environments/environment';

/**
 * Centralized logging service that respects environment settings.
 * In production builds, all console operations are no-ops to prevent
 * information disclosure and improve performance.
 */
@Injectable({
  providedIn: 'root'
})
export class LoggerService {
  /**
   * Logs an informational message
   * @param message The message to log
   * @param optionalParams Additional parameters to log
   */
  log(message?: any, ...optionalParams: any[]): void {
    if (!environment.production) {
      console.log(message, ...optionalParams);
    }
  }

  /**
   * Logs an error message
   * @param message The error message to log
   * @param optionalParams Additional parameters to log
   */
  error(message?: any, ...optionalParams: any[]): void {
    if (!environment.production) {
      console.error(message, ...optionalParams);
    }
  }

  /**
   * Logs a warning message
   * @param message The warning message to log
   * @param optionalParams Additional parameters to log
   */
  warn(message?: any, ...optionalParams: any[]): void {
    if (!environment.production) {
      console.warn(message, ...optionalParams);
    }
  }

  /**
   * Logs an informational message (alias for log)
   * @param message The message to log
   * @param optionalParams Additional parameters to log
   */
  info(message?: any, ...optionalParams: any[]): void {
    if (!environment.production) {
      console.info(message, ...optionalParams);
    }
  }

  /**
   * Logs a debug message
   * @param message The debug message to log
   * @param optionalParams Additional parameters to log
   */
  debug(message?: any, ...optionalParams: any[]): void {
    if (!environment.production) {
      console.debug(message, ...optionalParams);
    }
  }

  /**
   * Creates a table from data (for debugging)
   * @param data The data to display in table format
   */
  table(data?: any): void {
    if (!environment.production) {
      console.table(data);
    }
  }
}
